/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const CheckoutHeaderSkeleton = (props) => (
    <ContentLoader
        height={120}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderBottom: SkeletonSettings.BORDER}}
        {...props}>

        {/* Logo */}
        <rect x="0" y={`calc(50% - 40px)`} width="16%" height="80"/>

        {/* Steps */}
        <rect x={`calc(40% - 60px)`} y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>
        <rect x={`calc(55% - 40px)`} y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>
        <rect x={`calc(70% - 20px)`} y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>
        <rect x="85%" y={`calc(50% - 5px)`} rx="3" ry="3" width="15%" height="10"/>

    </ContentLoader>
)
